/** Parse NestJS / class-validator error body */
export function getApiErrorMessage(data: unknown, fallback: string): string {
  if (!data || typeof data !== 'object') return fallback
  const m = (data as { message?: unknown }).message
  if (typeof m === 'string') return m
  if (Array.isArray(m) && m.length > 0 && typeof m[0] === 'string') return m[0]
  return fallback
}
